import { Link } from 'react-router-dom';
import './Logo.css';

function Logo() {
  return (
    <Link to="/">
      <img src="/images/logo.png" alt="Логотип ВДПО" className="logo"/>
    </Link>
  );
}

export default Logo;
